import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { DrawerProvider } from './contexts/DrawerContext'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <DrawerProvider>
        <Suspense fallback={
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <div className="inline-block h-8 w-8 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
              <p className="mt-4 text-gray-600 text-sm">Loading...</p>
            </div>
          </div>
        }>
          <AppRoutes />
        </Suspense>
      </DrawerProvider>
    </BrowserRouter>
  )
}

export default App